import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { ESTADOS_CIERRE_INVENTARIO_BODEGA } from "../../../../../../../../../../utility/constants";
const verIcon = require("assets/img/icons/ver.png");
const editarIcon = require("assets/img/icons/editar.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const exportarIcon = require("assets/img/icons/download.png");
const reabrirIcon = require("assets/img/icons/refresh.png");

export const CierresTable = ({
    cierres,
    onCancelar,
    onReabrir,
    onDescargarExcel,
}) => {
    return (
        <div className="new-table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>No. de cierre</th>
                        <th>Fecha - hora de corte</th>
                        <th>Estado</th>
                        <th>Fecha - hora de registro</th>
                        <th>Responsable</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {cierres.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center">
                                No hay cierres de inventario registrados
                            </td>
                        </tr>
                    )}
                    {cierres.map((item) => {
                        const enProceso =
                            item.estado ===
                            ESTADOS_CIERRE_INVENTARIO_BODEGA.ABIERTO;

                        return (
                            <tr key={item.id}>
                                <td className="text-center text-nowrap">
                                    {item.numero || "Por definir"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_corte
                                        ? moment(item.fecha_corte).format(
                                              "DD/MM/YYYY - HH:mm",
                                          )
                                        : "Por definir"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.estado_display}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_creacion
                                        ? moment(item.fecha_creacion).format(
                                              "DD/MM/YYYY - HH:mm",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.usuario_nombre || "No definido"}
                                </td>
                                <td className="text-center text-nowrap">
                                    <div className="table-actions">
                                        {/* el documento en proceso se sigue
                                        trabajando en su propia pantalla */}
                                        {enProceso ? (
                                            <Link to="/produccion-bodega/inventario/crear-cierre">
                                                <img
                                                    src={editarIcon}
                                                    alt="Continuar"
                                                    className="action_img"
                                                    title="Continuar"
                                                />
                                            </Link>
                                        ) : (
                                            <Link
                                                to={`/produccion-bodega/inventario/cierre/${item.id}`}
                                            >
                                                <img
                                                    src={verIcon}
                                                    alt="Ver"
                                                    className="action_img"
                                                    title="Ver"
                                                />
                                            </Link>
                                        )}

                                        {!enProceso && (
                                            <img
                                                src={exportarIcon}
                                                alt="Exportar a Excel"
                                                className="action_img"
                                                title="Exportar a Excel"
                                                onClick={() =>
                                                    onDescargarExcel(item)
                                                }
                                            />
                                        )}

                                        {/* de los cerrados solo se reabre el
                                        último; una vez reabierto, se puede
                                        cancelar como cualquier cierre en
                                        proceso */}
                                        {enProceso && (
                                            <img
                                                src={eliminarIcon}
                                                alt="Cancelar"
                                                className="action_img"
                                                title="Cancelar"
                                                onClick={() => onCancelar(item)}
                                            />
                                        )}
                                        {!enProceso && item.es_ultimo && (
                                            <img
                                                src={reabrirIcon}
                                                alt="Reabrir"
                                                className="action_img"
                                                title="Reabrir"
                                                onClick={() => onReabrir(item)}
                                            />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
